import React, { useState } from 'react';
import api from '../utils/api';
import afdelingen from '../data/afdelingen.json';

export default function MijnProfielPage({ user, onUserUpdate }) {
  const [afdStatus, setAfdStatus] = useState(null);
  const [emailForm, setEmailForm] = useState({ nieuwEmail: user?.email || '', huidigWachtwoord: '' });
  const [wachtwoordForm, setWachtwoordForm] = useState({ huidigWachtwoord: '', nieuwWachtwoord: '', bevestig: '' });
  const [emailStatus, setEmailStatus] = useState(null);
  const [wachtwoordStatus, setWachtwoordStatus] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [wachtwoordLoading, setWachtwoordLoading] = useState(false);

  const handleEmailWijzigen = async (e) => {
    e.preventDefault();
    setEmailStatus(null);
    if (!emailForm.nieuwEmail.trim()) return setEmailStatus({ ok: false, bericht: 'Vul een e-mailadres in' });
    if (!emailForm.huidigWachtwoord) return setEmailStatus({ ok: false, bericht: 'Vul uw huidig wachtwoord in' });
    setEmailLoading(true);
    try {
      const res = await api.put('/auth/profiel', {
        nieuwEmail: emailForm.nieuwEmail.trim(),
        huidigWachtwoord: emailForm.huidigWachtwoord,
      });
      onUserUpdate(res.data);
      setEmailForm(f => ({ ...f, huidigWachtwoord: '' }));
      setEmailStatus({ ok: true, bericht: 'E-mailadres bijgewerkt' });
    } catch (err) {
      setEmailStatus({ ok: false, bericht: err.response?.data?.error || 'Fout bij opslaan' });
    } finally {
      setEmailLoading(false);
    }
  };

  const handleWachtwoordWijzigen = async (e) => {
    e.preventDefault();
    setWachtwoordStatus(null);
    if (!wachtwoordForm.huidigWachtwoord) return setWachtwoordStatus({ ok: false, bericht: 'Vul uw huidig wachtwoord in' });
    if (wachtwoordForm.nieuwWachtwoord.length < 6) return setWachtwoordStatus({ ok: false, bericht: 'Nieuw wachtwoord moet minimaal 6 tekens bevatten' });
    if (wachtwoordForm.nieuwWachtwoord !== wachtwoordForm.bevestig) return setWachtwoordStatus({ ok: false, bericht: 'Wachtwoorden komen niet overeen' });
    setWachtwoordLoading(true);
    try {
      await api.put('/auth/profiel', {
        huidigWachtwoord: wachtwoordForm.huidigWachtwoord,
        nieuwWachtwoord: wachtwoordForm.nieuwWachtwoord,
      });
      setWachtwoordForm({ huidigWachtwoord: '', nieuwWachtwoord: '', bevestig: '' });
      setWachtwoordStatus({ ok: true, bericht: 'Wachtwoord bijgewerkt' });
    } catch (err) {
      setWachtwoordStatus({ ok: false, bericht: err.response?.data?.error || 'Fout bij opslaan' });
    } finally {
      setWachtwoordLoading(false);
    }
  };

  const labelStijl = { fontSize: 12, color: '#555', fontWeight: 500, marginBottom: 4, display: 'block' };
  const inputStijl = { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 5, fontSize: 13, boxSizing: 'border-box' };
  const knopStijl = (laden) => ({
    padding: '8px 20px', background: laden ? '#aaa' : '#185FA5', color: '#fff',
    border: 'none', borderRadius: 5, fontSize: 13, cursor: laden ? 'default' : 'pointer', fontWeight: 500,
  });

  const slaAfdelingOp = async (afdId) => {
    setAfdStatus(null);
    try {
      const res = await api.patch('/auth/afdeling', { standaard_afdeling: afdId || null });
      if (onUserUpdate) onUserUpdate(res.data);
      setAfdStatus({ ok: true, bericht: afdId ? 'Standaard afdeling opgeslagen' : 'Standaard afdeling gewist' });
    } catch {
      setAfdStatus({ ok: false, bericht: 'Fout bij opslaan' });
    }
  };

  return (
    <div style={{ padding: 32, maxWidth: 520 }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: '#1F3864', marginBottom: 6 }}>Mijn profiel</h2>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 28 }}>Ingelogd als: {user?.naam} ({user?.rol})</div>

      {/* Standaard afdeling (voor werkvloer-gebruikers) */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e5e5', padding: 24, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 6 }}>Standaard afdeling (Productie)</div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
          Kies jouw afdeling — die wordt automatisch geselecteerd op de Productiepagina.
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 14 }}>
          <button onClick={() => slaAfdelingOp(null)} style={{
            padding: '6px 14px', borderRadius: 99, fontSize: 12, cursor: 'pointer',
            border: !user?.standaard_afdeling ? '2px solid #185FA5' : '1px solid #DDD',
            background: !user?.standaard_afdeling ? '#E6F1FB' : '#fff',
            color: !user?.standaard_afdeling ? '#185FA5' : '#555',
            fontWeight: !user?.standaard_afdeling ? 600 : 400,
          }}>Geen voorkeur</button>
          {afdelingen.map(a => (
            <button key={a.id} onClick={() => slaAfdelingOp(a.id)} style={{
              padding: '6px 14px', borderRadius: 99, fontSize: 12, cursor: 'pointer',
              border: user?.standaard_afdeling === a.id ? '2px solid #D85A30' : '1px solid #DDD',
              background: user?.standaard_afdeling === a.id ? '#FDEEE8' : '#fff',
              color: user?.standaard_afdeling === a.id ? '#D85A30' : '#555',
              fontWeight: user?.standaard_afdeling === a.id ? 600 : 400,
            }}>{a.naam}</button>
          ))}
        </div>
        {afdStatus && (
          <div style={{ fontSize: 12, color: afdStatus.ok ? '#2d7a2d' : '#A32D2D', padding: '6px 10px', background: afdStatus.ok ? '#eaf6ea' : '#fdf0f0', borderRadius: 4 }}>
            {afdStatus.bericht}
          </div>
        )}
      </div>

      {/* E-mail wijzigen */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e5e5', padding: 24, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 16 }}>E-mailadres wijzigen</div>
        <form onSubmit={handleEmailWijzigen}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStijl}>Nieuw e-mailadres</label>
            <input
              type="email"
              value={emailForm.nieuwEmail}
              onChange={e => setEmailForm(f => ({ ...f, nieuwEmail: e.target.value }))}
              style={inputStijl}
              autoComplete="email"
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={labelStijl}>Huidig wachtwoord (ter bevestiging)</label>
            <input
              type="password"
              value={emailForm.huidigWachtwoord}
              onChange={e => setEmailForm(f => ({ ...f, huidigWachtwoord: e.target.value }))}
              style={inputStijl}
              autoComplete="current-password"
            />
          </div>
          {emailStatus && (
            <div style={{ fontSize: 12, color: emailStatus.ok ? '#2d7a2d' : '#A32D2D', marginBottom: 12, padding: '6px 10px', background: emailStatus.ok ? '#eaf6ea' : '#fdf0f0', borderRadius: 4 }}>
              {emailStatus.bericht}
            </div>
          )}
          <button type="submit" style={knopStijl(emailLoading)} disabled={emailLoading}>
            {emailLoading ? 'Opslaan…' : 'E-mail opslaan'}
          </button>
        </form>
      </div>

      {/* Wachtwoord wijzigen */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e5e5', padding: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 16 }}>Wachtwoord wijzigen</div>
        <form onSubmit={handleWachtwoordWijzigen}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStijl}>Huidig wachtwoord</label>
            <input
              type="password"
              value={wachtwoordForm.huidigWachtwoord}
              onChange={e => setWachtwoordForm(f => ({ ...f, huidigWachtwoord: e.target.value }))}
              style={inputStijl}
              autoComplete="current-password"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStijl}>Nieuw wachtwoord (min. 6 tekens)</label>
            <input
              type="password"
              value={wachtwoordForm.nieuwWachtwoord}
              onChange={e => setWachtwoordForm(f => ({ ...f, nieuwWachtwoord: e.target.value }))}
              style={inputStijl}
              autoComplete="new-password"
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={labelStijl}>Bevestig nieuw wachtwoord</label>
            <input
              type="password"
              value={wachtwoordForm.bevestig}
              onChange={e => setWachtwoordForm(f => ({ ...f, bevestig: e.target.value }))}
              style={inputStijl}
              autoComplete="new-password"
            />
          </div>
          {wachtwoordStatus && (
            <div style={{ fontSize: 12, color: wachtwoordStatus.ok ? '#2d7a2d' : '#A32D2D', marginBottom: 12, padding: '6px 10px', background: wachtwoordStatus.ok ? '#eaf6ea' : '#fdf0f0', borderRadius: 4 }}>
              {wachtwoordStatus.bericht}
            </div>
          )}
          <button type="submit" style={knopStijl(wachtwoordLoading)} disabled={wachtwoordLoading}>
            {wachtwoordLoading ? 'Opslaan…' : 'Wachtwoord opslaan'}
          </button>
        </form>
      </div>
    </div>
  );
}
